import { UserData } from "@src/to-be-removed/LocalData/User/UserData";
import { Utilities } from "@src/utils/utilities";
import { CSSProperties, useEffect, useState } from "react";
import { Popup } from "../Popup/Popup";
import { UserPopUp } from "../UserPopup/UserPopUp";

type UserImageViewProps = Readonly<{
  user?: UserData;
  imageURL?: string;
  userName?: string;
  bigImage?: boolean;
  onClick?: (url: string | undefined) => void;
  className?: string;
  size?: string | number;
  fontSize?: string | number;
  activateUserPopUp?: boolean;
}>;

export const UserImageView = (props: UserImageViewProps) => {
  const [userLoaded, setLoaded] = useState(props.user && props.user.loaded);
  const [imageURL, setURL] = useState(props.bigImage ? props.user?.profileImage?.fileURL : props.user?.profileImage_Small?.fileURL);

  useEffect(() => {
    let mounted = true;
    if (!userLoaded && props.user) {
      props.user.loadWithCompletionHandler((error) => {
        if (!error && mounted) setLoaded(true);
      });
    }

    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    if (props.bigImage) {
      setURL(props.user?.profileImage?.fileURL);
    } else {
      setURL(props.user?.profileImage_Small?.fileURL);
    }
  }, [props.user, props.bigImage]);

  let className = "user-image-box";
  if (props.className) {
    className += " " + props.className;
  }

  const style: CSSProperties = {};
  if (props.onClick) style.cursor = "pointer";
  if (props.size) {
    style.height = props.size;
    style.width = props.size;
  }
  const texStyle: CSSProperties = {};
  if (props.fontSize) texStyle.fontSize = props.fontSize;

  const displayUserPopUp = () => {
    if (props.user && props.activateUserPopUp) {
      Popup.present((id) => {
        if (props.user) return <UserPopUp id={id} user={props.user} />;
        else return <></>;
      });
    }
  };

  if (props.user) {
    if (imageURL) {
      return (
        <div className={className} onClick={() => (props.onClick ? props.onClick(imageURL) : displayUserPopUp())} style={style}>
          <img alt="" src={imageURL} />
        </div>
      );
    }
    const colors = props.user.userColors ?? [];
    const initials = Utilities.generateInitials(props.user.name);
    style.backgroundColor = "rgb(" + colors[0] + "," + colors[1] + "," + colors[2] + ")";
    let imageData = props.bigImage ? props.user.profileImage : props.user.profileImage_Small;
    if (!imageData?.loaded) {
      imageData?.loadFileURL(() => {
        if (imageData?.fileURL) setURL(imageData?.fileURL);
      });
    }

    return (
      <div className={className} onClick={() => (props.onClick ? props.onClick(imageURL) : displayUserPopUp())} style={style}>
        <p style={texStyle}>{initials}</p>
      </div>
    );
  }

  if (props.imageURL) {
    return (
      <div className={className} onClick={() => (props.onClick ? props.onClick(props.imageURL) : displayUserPopUp())} style={style}>
        <img alt="profile_image" src={props.imageURL} />
      </div>
    );
  }
  const initials = Utilities.generateInitials(props.userName ?? "");
  style.backgroundColor = "var(--primary-color)";

  return (
    <div className={className} onClick={() => (props.onClick ? props.onClick(imageURL) : displayUserPopUp())} style={style}>
      <p style={texStyle}>{initials}</p>
    </div>
  );
};
